/* eslint-disable */
import React, { useState, useEffect, useRef } from "react";

// ── SearchableSelect ──────────────────────────────────────────────────────────
export function SearchableSelect({ value, onChange, options, placeholder="Select...", style }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  useEffect(() => {
    const handler = e => { if (ref.current && !ref.current.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);
  const filtered = options.filter(o => o.toLowerCase().includes(q.toLowerCase()));
  return (
    <div ref={ref} style={{ position:"relative" }} onClick={e => e.stopPropagation()}>
      <div onClick={() => { setOpen(v => !v); setQ(""); }}
        style={{ ...style, cursor:"pointer", display:"flex", justifyContent:"space-between", alignItems:"center" }}>
        <span style={{ color:value?"inherit":"#94a3b8" }}>{value || placeholder}</span>
        <span style={{ fontSize:'var(--text-2xs)', opacity:'var(--opacity-disabled)' }}>▼</span>
      </div>
      {open && (
        <div style={{ position:"absolute", top:"100%", left:0, right:0, zIndex:'var(--z-toast)', background:"var(--card-bg)", border:"var(--border-emphasis) solid #e2e8f0", borderRadius:'var(--radius-md)', maxHeight:240, display:"flex", flexDirection:"column" }}>
          <div style={{ padding:"var(--space-sm) var(--space-md)", borderBottom:"var(--border-med) solid #f1f5f9" }}>
            <input autoFocus value={q} onChange={e => setQ(e.target.value)} placeholder="Search brand..."
              style={{ width:"100%", border:"var(--border-med) solid #e2e8f0", borderRadius:'var(--radius-md)', padding:"var(--space-sm) var(--space-md)", fontSize:'var(--text-sm)', outline:"none", boxSizing:"border-box" }} />
          </div>
          <div style={{ overflowY:"auto", flex:1 }}>
            {filtered.length === 0 && <div style={{ padding:"var(--space-md) var(--space-lg)", fontSize:'var(--text-xs)', color:"#94a3b8" }}>No results</div>}
            {filtered.map(o => (
              <div key={o} onClick={() => { onChange(o); setOpen(false); setQ(""); }}
                style={{ padding:"var(--space-md) var(--space-lg)", fontSize:'var(--text-sm)', cursor:"pointer", background:o===value?"#f0f9ff":"transparent", color:o===value?"#0369a1":"#1e293b", fontWeight:o===value?700:400 }}
                onMouseEnter={e => e.target.style.background="#f8fafc"}
                onMouseLeave={e => e.target.style.background=o===value?"#f0f9ff":"transparent"}>
                {o}
              </div>
            ))}
          </div>
        </div>
      )}
    </div>
  );
}

// ── MultiSelectFilter ─────────────────────────────────────────────────────────
export function MultiSelectFilter({ values, onChange, options, placeholder, T, inputSt, br }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const ref = useRef(null);
  const filtered = options.filter(o => !q || o.toLowerCase().includes(q.toLowerCase()));
  const isActive = values instanceof Set ? values.size > 0 : (values !== "All" && values !== "");

  useEffect(() => {
    const handler = (e) => { if (ref.current && !ref.current.contains(e.target)) { setOpen(false); setQ(""); } };
    document.addEventListener("mousedown", handler);
    return () => document.removeEventListener("mousedown", handler);
  }, []);

  const toggle = (o) => {
    const next = new Set(values instanceof Set ? values : []);
    if (next.has(o)) next.delete(o); else next.add(o);
    onChange(next);
  };

  const count = values instanceof Set ? values.size : 0;
  const label = count === 0 ? placeholder : count === 1 ? [...values][0] : `${placeholder} (${count})`;

  return (
    <div ref={ref} style={{ position:"relative", flexShrink:0 }}>
      <button onClick={()=>{ setOpen(o=>!o); setQ(""); }}
        style={{ ...inputSt, width:"auto", minWidth:90, fontSize:'var(--text-xs)', cursor:"pointer", display:"flex", alignItems:"center", gap:'var(--space-sm)',
          color:isActive?T.accent:T.textMuted, fontWeight:isActive?700:400, borderColor:isActive?T.accent:T.border,
          background:isActive?T.accent+"11":"transparent" }}>
        <span style={{ overflow:"hidden", textOverflow:"ellipsis", whiteSpace:"nowrap", maxWidth:120 }}>{label}</span>
        {isActive && <span onClick={e=>{e.stopPropagation();onChange(new Set());}} style={{ fontSize:'var(--text-sm)', opacity:'var(--opacity-soft)', lineHeight:'var(--lh-tight)', marginLeft:'var(--space-2xs)'}}>×</span>}
        <span style={{ fontSize:'var(--text-2xs)', opacity:'var(--opacity-disabled)', flexShrink:0 }}>▾</span>
      </button>
      {open && (
        <div style={{ position:"absolute", top:"calc(100% + 4px)", left:0, zIndex:'var(--z-modal)', background:T.cardBg,
          border:`var(--border-med) solid ${T.border}`, borderRadius:br, minWidth:200, maxHeight:300, display:"flex", flexDirection:"column" }}>
          <div style={{ padding:"var(--space-sm) var(--space-md)", borderBottom:`var(--border-med) solid ${T.border}`, flexShrink:0 }}>
            <input autoFocus value={q} onChange={e=>setQ(e.target.value)}
              placeholder={`Search ${placeholder}...`}
              style={{ ...inputSt, width:"100%", padding:"var(--space-xs) var(--space-sm)", fontSize:'var(--text-xs)' }}/>
          </div>
          {count > 0 && (
            <div style={{ padding:"var(--space-xs) var(--space-md)", borderBottom:`var(--border-med) solid ${T.border}`, display:"flex", gap:'var(--space-xs)', flexWrap:"wrap", flexShrink:0, maxHeight:72, overflowY:"auto" }}>
              {[...values].map(v => (
                <span key={v} style={{ display:"inline-flex", alignItems:"center", gap:'var(--space-2xs)', background:T.accent, color:T.accentText, fontSize:'var(--text-2xs)', fontWeight:'var(--weight-bold)', padding:"var(--space-2xs) var(--space-sm)", borderRadius:'var(--radius-pill)' }}>
                  {v}<button onClick={()=>toggle(v)} style={{ background:"none",border:"none",color:T.accentText,cursor:"pointer",padding:0,fontSize:'var(--text-xs)',lineHeight:'var(--lh-tight)',opacity:'var(--opacity-soft)' }}>×</button>
                </span>
              ))}
            </div>
          )}
          <div style={{ overflowY:"auto", flex:1 }}>
            {count > 0 && (
              <div onClick={()=>onChange(new Set())}
                style={{ padding:"var(--space-sm) var(--space-lg)", cursor:"pointer", fontSize:'var(--text-xs)', color:T.textMuted, fontStyle:"italic", borderBottom:`var(--border-med) solid ${T.border}` }}>
                ✕ Clear all
              </div>
            )}
            {filtered.length === 0 && <div style={{ padding:"var(--space-md) var(--space-lg)", fontSize:'var(--text-xs)', color:T.textMuted }}>No results</div>}
            {filtered.map(o => {
              const sel = values instanceof Set && values.has(o);
              return (
                <div key={o} onClick={()=>toggle(o)}
                  style={{ padding:"var(--space-sm) var(--space-lg)", cursor:"pointer", fontSize:'var(--text-xs)', display:"flex", alignItems:"center", gap:'var(--space-sm)',
                    background:sel?T.accent+"18":T.cardBg, color:sel?T.accent:T.textPrimary, fontWeight:sel?700:400 }}
                  onMouseEnter={e=>{ if(!sel) e.currentTarget.style.background=T.mainBg; }}
                  onMouseLeave={e=>{ if(!sel) e.currentTarget.style.background=T.cardBg; }}>
                  <span style={{ width:14, height:14, border:`var(--border-thick) solid ${sel?T.accent:T.border}`, borderRadius:'var(--radius-sm)', background:sel?T.accent:"transparent", display:"flex", alignItems:"center", justifyContent:"center", flexShrink:0, fontSize:'var(--text-2xs)', color:T.accentText }}>{sel?"✓":""}</span>
                  {o}
                </div>
              );
            })}
          </div>
        </div>
      )}
    </div>
  );
}
